var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen",attrs:{"id":"app"}},[_c('router-view'),_c('WhatsAppFloat'),(_vm.showAuthModal)?_c('AuthModal',{on:{"close":_vm.closeAuthModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }